import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import M from 'materialize-css';
import { Container, Col, Modal, RadioGroup, TextInput, Collection, CollectionItem } from 'react-materialize';
import styled from 'styled-components';
import { SIZE, LABEL, COLOR, FONT_FAMILY, URL, SCREEN_MEDIA } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes.js';
import { useDecorationPortraits } from '../hooks/useDecorationPortraits.js';
import {
    getPortraitsByCatLv1Id,
    getBirtOptions,
    getTypeCode
} from '../../utils/managertypes.js';
import { getTypesFromSearchPhrase } from '../../utils/managersearch.js';
import Row from '../organism/row.jsx';
import Path from '../molecules/path.jsx';
import Button from '../atoms/button.jsx';
import TextIcon from '../atoms/texticon.jsx';
import FixedButtons from '../molecules/fixedbuttons.jsx';
import Photos from '../organism/photos.jsx';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Label } from '../atoms/label.jsx';
import LoadingSpinner from '../organism/spinner.jsx';



import PathWapp from '../../icons/ic_wapp.svg';
import PathFb from '../../icons/ic_fb_colored.svg';
import PathTikTok from '../../icons/ic_tiktok.svg';
import PathInsta from '../../icons/ic_instagram_colored.svg';

import PathIcSarch from '../../icons/ic_search.svg'

import PathImgModalBackground from '../../images/img_cold_spark.webp'


const RadioContent = styled.div`
    [type="radio"] {
        &:checked+span {
            &::before {
                border: 2px solid ${COLOR.ferra};
            }
            &:after {
                background-color: ${COLOR.ferra};
                border: 1px solid ${COLOR.ferra};
            }
        }
    }
    label {
        color: ${COLOR.ferra};
        font-size: 36px;
        width: 100%;
        display: inline-block;
    }
`


const TextInputLayer = styled.div`
    height: 45px;
    width: 100%;
    border: 2px solid ${COLOR.ferra};
    border-radius: 4px;
    cursor: text;
`;


const SearchSuggestionBackground = styled.div`
    height: 100%; // It is not working, this is set dynamically
    width: 100%;
    position: absolute;
    background-color: ${COLOR.background};
    display: none;
    @media only screen and ${SCREEN_MEDIA.small} {
        top: 56px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        top: 64px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        top: 64px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        top: 64px;
    }
    z-index: 1;
`;

const SearcherSuggestionDiv = styled.div`
    height: 400px;
    background-color: ${COLOR.white};
    overflow: auto;
    position: absolute;
    @media only screen and ${SCREEN_MEDIA.small} {
        width:90%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        width:85%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        width:70%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        width:70%;
        top: 90px;
    }
`


const ThematicsGrid = styled.div`
    display: grid;
    @media only screen and ${SCREEN_MEDIA.small} {
        grid-template-columns: 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        grid-template-columns: 1fr 1fr;
    }
`;

const ThematicItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;

const BodyThematic = () => {

    const { data: typeList, isLoading: isTypesLoading } = useDecorationTypes();
    const { data: portraitList, isLoading: isPortraitsLoading } = useDecorationPortraits();

    const isLoading = isTypesLoading || isPortraitsLoading || !typeList || !portraitList;

    const typeCatLv1List = useMemo(() => {
        return typeList ? typeList.categoriesLv1 : [];
    }, [typeList]);

    const birthOptions = useMemo(() => {
        return typeList ? getBirtOptions(typeList) : [];
    }, [typeList]);


    const [subcategoryBirthModal, setSubcategoryBirthModal] = useState();
    const [searchSuggestionList, setSearchSuggestionList] = useState([])
    const [birthOptionSelectedId, setBirthOptionSelectedId] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();

    // Set when arriving here right after a successful event booking submission
    // (bodybookingreate.jsx navigates here with this in router state) - used
    // to show a confirmation modal.
    const [bookingSuccess, setBookingSuccess] = useState(Boolean(location.state?.bookingSuccess));
    const [bookingSuccessModal, setBookingSuccessModal] = useState();

    const searchInputTextRef = useRef()


    useEffect(() => {
        if (birthOptions.length > 0 && !birthOptionSelectedId) {
            setBirthOptionSelectedId(birthOptions[0].value);
        }
    }, [birthOptions, birthOptionSelectedId]);

    useEffect(() => {
        if (typeCatLv1List && typeCatLv1List.length > 0) {
            setSearchSuggestionList(typeCatLv1List)
        }
    }, [typeCatLv1List]);

    useEffect(() => {
        if (!isLoading) {
            window.scrollTo(0, 0);
            
            var birthModal = M.Modal.getInstance($('#modalBirthSubcategoriesId')); // Init modal
            setSubcategoryBirthModal(birthModal);
        }
      }, [isLoading]);

    useEffect(() => {
        // Clear the router state right after consuming it, so navigating away
        // and back (e.g. browser back button) doesn't replay it against the
        // same history entry and reopen the modal.
        if (location.state?.bookingSuccess) {
            navigate(location.pathname, { replace: true, state: {} });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isLoading && bookingSuccess) { // RENDER IS DONE
            var bookingModal = M.Modal.getInstance($('#bookingSuccessModal')); // Init modal
            setBookingSuccessModal(bookingModal);

            bookingModal.open();

            var modalDiv = $('#bookingSuccessModal').find('.modal-content')
            modalDiv.css("background-image", `url(${PathImgModalBackground})`);
            modalDiv.css("background-position", "50% 50%");
            modalDiv.css("background-size", "cover");
            modalDiv.css("background-repeat", "no-repeat");
            modalDiv.css("position", "relative");

            var modalH4 = $(`#bookingSuccessModal h4`)
            modalH4.css("font-family", FONT_FAMILY.avenirBook);
        }
        
    }, [isLoading, bookingSuccess])

    const onSubcategoryBirthApplied = () => {
        subcategoryBirthModal.close()
        const path = URL.decorations.replace(':typeCode', birthOptionSelectedId);
        navigate(path)
    }

    const navigateToDecorations = (typeCode) => {
        console.log(`Thematic typeCode: ${typeCode}`)
        const path = URL.decorations.replace(':typeCode', typeCode);
        navigate(path)
    }

    const handleSearchOnkeyDown = (event) => {
        if (event.key === 'Enter') {
        }
    }

    const handleOnSearchDismissed = () => {
        $(searchInputTextRef.current).blur()
        $('#search_suggestion_background').css('display', 'none')
    }

    const onSearchInputLayerClicked = () => {
        $('#search_suggestion_background').css('height', $('#root').height());
        $('#search_suggestion_background').css('display', 'block')
        $(searchInputTextRef.current).focus()
    }

    const onSearchInputTextChanges = (event) => {
        const searchPhrase = event.target.value.trim()
        const suggestionList = getTypesFromSearchPhrase(typeList, searchPhrase)
        setSearchSuggestionList(suggestionList)
    }

    const onThematicItemClicked = (typeCatLv1) => {
        if (typeCatLv1.id === 1) {
            subcategoryBirthModal.open()
        } else {
            const typeCode = getTypeCode(typeCatLv1)
            navigateToDecorations(typeCode)
        }
    }

    if (isLoading) return <LoadingSpinner/>;

    return(
        <div>
  
            <Container>
                <FixedButtons
                    items={[
                        { href: URL.whatsapp, ic_path: PathWapp, ic_size: '50px' },
                        { href: URL.facebook, ic_path: PathFb, ic_size: '50px' },
                        { href: URL.tiktok, ic_path: PathTikTok, ic_size: '50px' },
                        { href: URL.instagram, ic_path: PathInsta, ic_size: '50px' }
                        ]}
                    aligment='right'/>

                <Row className='valign-wrapper' margin='40px 0'>
                    <TextInputLayer
                        onClick={ () => { onSearchInputLayerClicked() } }>
                        <Label
                        text_color={COLOR.gray}
                        text_size='20px'
                        font_family={FONT_FAMILY.avenirBook}
                        margin='7px 14px'>
                        Buscar temática
                        </Label>
                    </TextInputLayer>
                </Row>
                

                <Row
                    margin='0 0'>
                    <Path 
                        endpoint={LABEL.thematics} />
                </Row>

                <ThematicsGrid>
                {
                    typeCatLv1List?.map((item, index) => {
                        const portraitsByType = getPortraitsByCatLv1Id(portraitList, item.id)
                        return <ThematicItem key={item.id} onClick={() => { onThematicItemClicked(item) }}>
                            <Photos
                            photo_01_src={ portraitsByType[0].src }
                            photo_01_rotation='10deg'
                            photo_02_src={ portraitsByType[1].src }
                            photo_02_rotation='-2deg'
                            photo_03_src={ portraitsByType[2].src }
                            photo_03_rotation='-10deg'
                            margin='60px 0 10px 0'/>
                            <Label
                            text_size={SIZE.display}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.avenirLight}>
                            { item.title }
                            </Label>
                        </ThematicItem>
                    })
                }
                </ThematicsGrid>

                <Modal
                    id="modalBirthSubcategoriesId"
                    header="Selecciona una subcategoría"
                    fixedFooter={ true } //If true breaks DatePickers
                    actions={[
                    <Button 
                        onClick={() => { onSubcategoryBirthApplied() }}
                        width='120px'
                        height='46px'
                        bg_color={COLOR.primary}
                        float='right'>
                        <Label
                            text_color={ COLOR.ferra }
                            text_size={SIZE.headline}
                            font_family={FONT_FAMILY.unicorns}
                            margin='auto'>
                            Aplicar
                        </Label>
                    </Button>
                    ]}>
                    <Row margin='30px 0 0 0'>
                        <RadioContent>
                        <RadioGroup
                            label="Birth-filter"
                            name="size"
                            className='valign-wrapper'
                            withGap={ true }
                            options={ birthOptions }
                            value={ birthOptionSelectedId }
                            onChange={(event) => setBirthOptionSelectedId(event.target.value)}
                            />
                        </RadioContent>
                    </Row>
                </Modal>

                <Modal
                    id="bookingSuccessModal"
                    fixedFooter={ false } //If true breaks DatePickers
                    actions={[
                    <Button 
                        onClick={() => { bookingSuccessModal.close() }}
                        width='120px'
                        height='46px'
                        bg_color={COLOR.primary}
                        float='right'>
                        <Label
                            text_color={ COLOR.ferra }
                            text_size={SIZE.title}
                            font_family={FONT_FAMILY.noteworthyLight}
                            margin='auto'>
                            { LABEL.close }
                        </Label>
                    </Button>
                    ]}>
                    <Row className='valign-wrapper' margin='20px 0 0 0'>
                        <Label
                            text_color={ COLOR.primaryDark }
                            text_size={SIZE.title}
                            font_family={FONT_FAMILY.avenirMedium}
                            margin='auto'>
                            Gracias por reservar
                        </Label>
                        <Label
                            text_color={ COLOR.white }
                            text_size={SIZE.title}
                            font_family={FONT_FAMILY.avenirLight}
                            margin='10px auto'>
                            En breve nos pondremos en contacto para confirmar los datos.
                        </Label>
                        <Label
                            text_color={ COLOR.white }
                            text_size={SIZE.title}
                            font_family={FONT_FAMILY.avenirMedium}
                            margin='40px auto 0px'>
                            ¡Aprovecha nuestra oferta de Chisperos y haz que tu evento luzca deslumbrante!
                        </Label>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <Label
                                text_color={ COLOR.gold }
                                text_size={SIZE.title}
                                font_family={FONT_FAMILY.avenirBlack}
                                margin='20px auto 0px'>
                                1 ejecución: S/.100
                            </Label>
                            <Label
                                text_color={ COLOR.gold }
                                text_size={SIZE.title}
                                font_family={FONT_FAMILY.avenirBlack}
                                margin='10px auto'>
                                2 ejecuciones: S/.180
                            </Label>
                            <Label
                                text_color={ COLOR.primary }
                                text_size={SIZE.body}
                                font_family={FONT_FAMILY.avenirLight}
                                margin='10px 0 0 0'>
                                * Duración de ejecución: 30 segundos.
                            </Label>
                            <Label
                                text_color={ COLOR.primary }
                                text_size={SIZE.body}
                                font_family={FONT_FAMILY.avenirLight}
                                margin='0 0 0 0'>
                                * Altura de alcance: 1.5 - 2m.
                            </Label>
                        </div>
                    </Row>
                </Modal>
  
            </Container>

            <SearchSuggestionBackground
                id='search_suggestion_background'
                onClick={ () => { handleOnSearchDismissed() } }>
                <Container>
                <Row margin='40px 0'>
                    <Col s={8} m={8} l={10} xl={11}>
                        <TextInput
                        ref={searchInputTextRef}
                        placeholder='Buscar temática'
                        onChange={ (event) => { onSearchInputTextChanges(event) } }
                        onKeyDown={ (event) => { handleSearchOnkeyDown(event) } }/>
                    </Col>
                    <Col s={4} m={4} l={2} xl={1}>
                    <Button
                        onClick={ () => { handleOnSearchDismissed() } }
                        height='40px'>
                        <Label
                        font_family={FONT_FAMILY.avenirLight}
                        text_color={COLOR.ferra}>
                            { LABEL.cancel }
                        </Label>
                    </Button>
                    
                    </Col>
                </Row>
                <Row>
                    <SearcherSuggestionDiv>
                    <Collection>
                    {
                        searchSuggestionList.map((searchSuggestion, index) =>
                            <CollectionItem
                                key={index}
                                onClick={ () => { navigateToDecorations(getTypeCode(searchSuggestion)) } }
                                style={{ cursor: 'pointer' }}>
                                <TextIcon
                                    ic_path={PathIcSarch}
                                    ic_size='18px'
                                    ic_color={COLOR.ferra}>
                                </TextIcon>
                                <Label
                                    text_size={SIZE.subtitle}
                                    text_color={COLOR.ferra}
                                    font_family={FONT_FAMILY.avenirMedium}> 
                                    {searchSuggestion.title}
                                </Label>
                                
                            </CollectionItem>
                        )
                    }
                    </Collection>
                    </SearcherSuggestionDiv>
                </Row>
                </Container>
            </SearchSuggestionBackground>

        </div>
    );
}

export default BodyThematic;